module.exports = __webpack_public_path__ + "static/media/competence.564d5344.png";